var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-copyright",
    "data-name": "Icon metro-copyright",
    d: "M13.754,11.8v.852a.989.989,0,0,1-.285.7,1.9,1.9,0,0,1-.734.473,5.37,5.37,0,0,1-.922.254,5.128,5.128,0,0,1-.918.086,3.611,3.611,0,0,1-2.676-1.086,3.69,3.69,0,0,1-1.074-2.7,3.631,3.631,0,0,1,3.711-3.711,5.513,5.513,0,0,1,.59.035,5.041,5.041,0,0,1,.727.141,3.727,3.727,0,0,1,.723.266,1.556,1.556,0,0,1,.539.441,1,1,0,0,1,.219.633v.852a.11.11,0,0,1-.125.125h-.922a.11.11,0,0,1-.125-.125V8.477q0-.336-.512-.527a3.041,3.041,0,0,0-1.074-.191,2.374,2.374,0,0,0-1.785.715,2.557,2.557,0,0,0-.691,1.855,2.752,2.752,0,0,0,.715,1.949,2.38,2.38,0,0,0,1.824.77,3.31,3.31,0,0,0,1.078-.187q.547-.187.547-.516V11.8a.122.122,0,0,1,.035-.09.112.112,0,0,1,.082-.035h.93a.126.126,0,0,1,.086.035.116.116,0,0,1,.039.09ZM10.77,5.407a4.86,4.86,0,0,0-1.941.4,4.931,4.931,0,0,0-2.66,2.66,4.929,4.929,0,0,0,0,3.883,4.931,4.931,0,0,0,2.66,2.66,4.929,4.929,0,0,0,3.883,0,4.931,4.931,0,0,0,2.66-2.66,4.929,4.929,0,0,0,0-3.883,4.931,4.931,0,0,0-2.66-2.66,4.86,4.86,0,0,0-1.941-.4Zm6,5a5.869,5.869,0,0,1-.8,3.012A5.973,5.973,0,0,1,13.782,15.6a6.038,6.038,0,0,1-6.023,0,5.973,5.973,0,0,1-2.184-2.184,6.038,6.038,0,0,1,0-6.023A5.973,5.973,0,0,1,7.758,5.212a6.038,6.038,0,0,1,6.023,0A5.973,5.973,0,0,1,15.965,7.4,5.869,5.869,0,0,1,16.77,10.407Z",
    transform: "translate(-4.77 -4.407)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyRightIcon);
export default __webpack_public_path__ + "static/media/copyRightIcon.f4f3163e4f699425862dbf221f78dee3.svg";
export { ForwardRef as ReactComponent };